import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=603e5dcd&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "./Information.vue?vue&type=style&index=0&id=603e5dcd&prod&scoped=true&lang=css"
import style1 from "./Information.vue?vue&type=style&index=1&id=603e5dcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603e5dcd",
  null
  
)

export default component.exports